document.addEventListener('DOMContentLoaded', async function () {
    let isFirstLoad = true;

    // --- Generate HMAC SHA256 for API auth ---
    const generateHmacSha256 = async (message, secretKey) => {
        const enc = new TextEncoder();
        const key = await crypto.subtle.importKey(
            'raw',
            enc.encode(secretKey),
            { name: 'HMAC', hash: 'SHA-256' },
            false,
            ['sign']
        );
        const signature = await crypto.subtle.sign('HMAC', key, enc.encode(message));
        return Array.from(new Uint8Array(signature))
            .map((b) => b.toString(16).padStart(2, '0'))
            .join('');
    };

    // --- Get fresh auth credentials ---
    const getFreshAuth = async () => {
        const domain = 'levis-india-store.myshopify.com';
        const timestamp = Date.now().toString();
        const hash = await generateHmacSha256(
            timestamp.slice(0, 4) + domain + timestamp.slice(4),
            'yTGfof2MPlM1bLlvKSM'
        );
        return { key: hash, timestamp };
    };

    // --- Parse points safely ---
    const parsePoints = (points) => (isNaN(parseInt(points, 10)) ? 0 : parseInt(points, 10));

    // --- Update RedTab points in cart ---
    const updatePointsDisplay = (points) => {
        const cartPoints = document.querySelector('.cart-available-redtab-points');
        if (!cartPoints) return;

        const parsedPoints = parseInt(points, 10) || 0;
        cartPoints.querySelector('.cart-available-points').innerText = parsedPoints;

        // ✅ Hide if points = 0, show otherwise
        cartPoints.style.display = parsedPoints > 0 ? '' : 'none';
    };

    // --- Fetch RedTab points from API ---
    const fetchPointsFromAPI = async (customerPhone) => {
        try {
            const { timestamp, key } = await getFreshAuth();
            const res = await fetch(
                'https://leviseasyrewards.marmeto.com/api/get/customer/available-points',
                {
                    method: 'POST',
                    headers: {
                        hash: key,
                        timestamp,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        easy_id: customerPhone,
                        activity_code: 'LevisRedeem',
                        store_code: 'EcommerceLevis',
                        country_code: '91',
                    }),
                }
            );

            const data = await res.json();
            if (data.success && data.data?.ReturnCode === 0) {
                const points = parsePoints(data.data.AvailablePoints);
                sessionStorage.setItem('availableRedTabPoints', points);
                updatePointsDisplay(points);
            } else {
                sessionStorage.setItem('availableRedTabPoints', 0);
                updatePointsDisplay(0);
            }
        } catch (e) {
            console.error('Error fetching points:', e);
            updatePointsDisplay(0);
        }
    };

    // --- Hide initially until data is known ---
    const cartPointsEl = document.querySelector('.cart-available-redtab-points');
    if (cartPointsEl) cartPointsEl.style.display = 'none'; // 👈 hide by default

    // --- Initialize cart points ---
    const cartDrawer = document.querySelector('cart-drawer');
    let customerPhone = cartDrawer?.dataset?.customerphone || '';
    if (customerPhone.startsWith('+91') && customerPhone.length > 10)
        customerPhone = customerPhone.slice(3);

    if (customerPhone) {
        // Load from cache first (if exists)
        const cachedPoints = sessionStorage.getItem('availableRedTabPoints');
        if (cachedPoints !== null) updatePointsDisplay(cachedPoints);

        // Always refresh in background (non-blocking)
        fetchPointsFromAPI(customerPhone);
    }

    // --- Event listeners for cart actions ---
    const refreshPointsInBackground = () => {
        if (customerPhone) fetchPointsFromAPI(customerPhone);
    };

    ['add_to_cart', 'cart-item-removed', 'change'].forEach((eventName) => {
        document.addEventListener(eventName, (e) => {
            if (eventName === 'change') {
                const input = e.target;
                if (!(input.closest('quantity-input') && input.closest('cart-drawer-items')))
                    return;
            }
            isFirstLoad = false;
            refreshPointsInBackground();
        });
    });

    document.addEventListener('cart-updated', () => {
        isFirstLoad = false;
        refreshPointsInBackground();
    });
});
